import HistoryIcon from '@mui/icons-material/History';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { AuditContainerCss, AuditItem } from '../../../../components/AuditDetails';
import { BasicDialog } from '../../../../components/Dialog/BasicDialog';
import { CompanyLogoAndName } from '../../../../components/grid-renderers/CompanyCellRenderer';
import { IDealDataModel } from '../../../../data-models/deal.data-model';
import { companyStateJ } from '../../../../services/state/CompanyStateJ';
import { FMT } from '../../../../util/formatter-service';
import { selectedDealState } from '../../state/DealboardUIStateJ';

const dealAuditAtom = atom(false);

export function useDealAuditMenuItem() {
  const setShowDealAudit = useSetAtom(dealAuditAtom);
  return {
    name: 'Show Audit',
    icon: <HistoryIcon />,
    onClick: () => setShowDealAudit(true),
    disabled: false,
    hide: false,
    divider: false,
    title: 'Show Audit',
  };
}

export function DealAuditModal() {
  const [showDealAudit, setShowDealAudit] = useAtom(dealAuditAtom);
  const deal = useAtomValue(selectedDealState);
  if (!deal) {
    return null;
  }
  return (
    <BasicDialog open={showDealAudit} onClose={() => setShowDealAudit(false)} title='Deal Audit' lightDismiss>
      <DealAuditContent deal={deal} />
    </BasicDialog>
  );
}

function DealAuditContent({ deal }: { deal: IDealDataModel }) {
  const company = useAtomValue(companyStateJ(deal.companyId));
  if (!company) {
    return null;
  }
  return (
    <div css={AuditContainerCss}>
      <CompanyLogoAndName logoUrl={company.logoUrl ?? ''} name={company.name} />
      <AuditItem label='Source' value={FMT.format('string', deal.source)} />
      <AuditItem label='Added' value={FMT.format('date', deal.createdAt ?? '')} />
      <AuditItem label='Last updated by' value={getDealUpdateData(deal) ?? ''} />
    </div>
  );
}

function getDealUpdateData(deal: IDealDataModel) {
  const { createdAt, createdBy, updatedAt, updatedBy } = deal;
  if (!createdBy && !updatedBy) {
    return null;
  }
  const user = updatedBy ?? createdBy;
  const time = updatedAt ?? createdAt;
  if (!user) {
    return null;
  }
  if (!time) {
    return FMT.format('userByEmail', user);
  }
  return `${FMT.format('userByEmail', user)} on ${FMT.format('date', time)}`;
}
